import React, { useEffect, useState } from "react"
import { Backdrop, CircularProgress, Paper, Typography } from "@mui/material"
import { Box } from "@mui/system"
import { styled } from "@mui/material/styles"

const StyledBackdrop = styled(Backdrop)(({ theme }) => ({
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
}))

const ProgressBackdrop = (props) => {
    const { label } = props

    const [isOpen, setOpen] = useState(props.open)

    const handleClose = () => {
        setOpen(false)
    }

    useEffect(() => {
        setOpen(props.open)
    }, [props.open])

    return (
        <StyledBackdrop open={isOpen} onClick={handleClose}>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    alignItems: "center",
                }}
            >
                <CircularProgress color="inherit" />
                {label && (
                    <Paper sx={{ marginTop: "10px", padding: "5px" }}>
                        <Typography>{label}</Typography>
                    </Paper>
                )}
            </Box>
        </StyledBackdrop>
    )
}

export default ProgressBackdrop
